import callAPiBase from './base';

const audioApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/stopGetAudio',
      method: 'GET',
      useToken: true,
      title: 'Audio - Get Audio',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/stopCreateAudio',
      method: 'POST',
      useToken: true,
      title: 'Audio - Create Audio',
      data,
    }),
};

export default audioApi;
export { audioApi };
